import { render, staticRenderFns } from "./AppRoot.vue?vue&type=template&id=8d39ef02&scoped=true&"
import script from "./AppRoot.vue?vue&type=script&lang=js&"
export * from "./AppRoot.vue?vue&type=script&lang=js&"
import style0 from "./AppRoot.vue?vue&type=style&index=0&id=8d39ef02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d39ef02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMain } from 'vuetify/lib/components/VMain';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VBtn,VMain,VMenu,VSnackbar})
